import { useEffect } from 'react';

type UseOutsideClickHandler = (event: MouseEvent | TouchEvent) => void;

const useOutsideClick = <T extends HTMLElement>(ref: React.RefObject<T>, handler: UseOutsideClickHandler): void => {
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent | TouchEvent): any => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        handler(event);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('touchstart', handleClickOutside); // For touch devices

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
    };
  }, [ref, handler]);
};

export default useOutsideClick;
